<template>
  <profile-edit-section-card
    v-if="localState"
    title="Services"
    breadcrumb-label="Profile"
    :saving="isSaving"
    :has-unsaved-changes="hasUnsavedChanges"
    @breadcrumb-click="cancelEdit"
    @save="handleSave"
    @cancel="cancelEdit"
  >
    <radio-button-group
      v-model="comfortableWithPetsValue"
      name="Are you comfortable with pets?"
      :options="yesNoOptions"
      class="mb-24"
    />
    <fieldset class="mb-24">
      <legend class="form__label !mb-0">What types of housekeeping services do you provide?</legend>
      <helper-text text="Required" class="pb-16 pl-0" />
      <ul>
        <li v-for="option in serviceTypeOptions" :key="option.value" class="mb-8">
          <poppins-checkbox v-model="localState.typesOfServices" :label-name="option.label" :value="option.value" />
        </li>
      </ul>
    </fieldset>
  </profile-edit-section-card>
</template>

<script lang="ts">
import PoppinsCheckbox from '@/components/checkbox/Checkbox.vue';
import ProfileEditSectionCard from '../../components/ProfileEditSectionCard.vue';
import RadioButtonGroup from '@/components/radioButtonGroup/RadioButtonGroup.vue';
import HelperText from '@/components/helper_text/HelperText.vue';
import profileEditMixin from '../../mixins/profileEditMixin';
import { HOUSEKEEPING_TYPES_OF_SERVICES_OPTIONS } from '../../__types__/CareTypeFormOptions';
import type { HousekeepingProfileFormState } from '../../__types__/HousekeepingProfileTypes';

export default {
  name: 'HousekeepingServicesForm',
  components: {
    ProfileEditSectionCard,
    RadioButtonGroup,
    PoppinsCheckbox,
    HelperText,
  },
  mixins: [profileEditMixin],
  data(): any {
    return {
      localState: null,
      originalState: null,
    };
  },
  computed: {
    errorUpdating(): boolean {
      return this.$attrs.errorUpdating as boolean;
    },
    yesNoOptions: () => [
      { value: 'true', label: 'Yes' },
      { value: 'false', label: 'No' },
    ],
    serviceTypeOptions: () => HOUSEKEEPING_TYPES_OF_SERVICES_OPTIONS,
    comfortableWithPetsValue: {
      get(): string {
        return String(this.localState?.comfortableWithPets ?? false);
      },
      set(value: string) {
        if (this.localState) {
          this.localState.comfortableWithPets = value === 'true';
        }
      },
    },
    hasUnsavedChanges(): boolean {
      if (!this.localState || !this.originalState) return false;
      return JSON.stringify(this.localState) !== JSON.stringify(this.originalState);
    },
  },
  watch: {
    $route() {
      this.initializeFormState();
    },
    formState: {
      handler(newState) {
        if (newState) {
          this.initializeFormState();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeFormState();
  },
  methods: {
    initializeFormState() {
      const state = this.formState as HousekeepingProfileFormState | null;
      if (!state) return;

      this.localState = {
        comfortableWithPets: state.comfortableWithPets ?? false,
        typesOfServices: [...(state.typesOfServices || [])],
      };
      this.originalState = JSON.parse(JSON.stringify(this.localState));
    },
    async handleSave() {
      if (!this.localState) return;

      if (this.hasUnsavedChanges) {
        await this.saveSection({
          comfortableWithPets: this.localState.comfortableWithPets,
          services: [...this.localState.typesOfServices],
        });
      }
    },
  },
};
</script>
